<template>
  <el-divider class="divider-bottom" />

  <div class="responsive-container legal-links">
    <nuxt-link class="text" to="/payment">Оплата</nuxt-link>
    <nuxt-link class="text" to="/delivery">Доставка</nuxt-link>
    <nuxt-link class="text" to="/return">Возврат товара</nuxt-link>
    <nuxt-link class="text" to="/contact">Реквизиты</nuxt-link>
    <nuxt-link class="text" to="/policy">Политика конфиденциальности</nuxt-link>
  </div>
  <div class="responsive-container">
    <div class="text">Производитель: ИП Шапошников С. Н.</div>
    <div class="text">Продавец: ИП Шапошникова С. Ю.</div>
    <div class="text">Производим с 1989 г.</div>
    <div class="text">© Продукция защищена авторским правом.</div>
  </div>
</template>

<style scoped>
.divider-bottom {
  margin-top: 0;
  margin-bottom: 10px;
}

.responsive-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  padding-bottom: 10px;
}

.text {
  white-space: nowrap;
  text-align: left;
  text-align: center;
  font-size: 0.9em;
}

.legal-links {
  gap: 4px 20px;
  padding-top: 10px;
}

.legal-links .text {
  color: var(--el-color-primary);
  text-decoration: none;
}

.legal-links .text:hover {
  text-decoration: underline;
}

</style>

<!-- <div>
            <span style="font-weight: 300;">Тел:</span> <span style="font-weight: 500;">+7 (905) 286-09-84</span><br>
            <span style="font-weight: 300;">Email:</span> <span style="font-weight: 500;">opt@smaildell.ru</span>
        </div> -->
